import {
    Row, Col, Typography, Form, 
} from 'antd';
import {
    EditOutlined, PlusOutlined, CalendarOutlined
} from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import DataCards from '../../components/data/DataCards.jsx';
import { ViewNextServiceDetail } from './SummaryTabbedCanvas';
import ReviewAncillaryBookingRequest from '../../sections/maintenance/ReviewAncillaryBookingRequest';


const AncillariesCardView = ({ vehicle, vehicleAncillaries, currentRequest, setCurrentRequest, isViewAncillaryRequestModalVisible, 
                               setIsViewAncillaryRequestModalVisible}) => {

    const { t } = useTranslation();
    const [ancillaryForm] = Form.useForm();

    const editAncillaryRequest = (ancillary, currentRequest) => {
        

        // when the work request is submitted to the back office, the currentRequest object is initialised along with popupAncillary being removed from the object itself
        // hence included below check
        if (!currentRequest?.hasOwnProperty('popupAncillary')){
            currentRequest.popupAncillary = {};
        }

        currentRequest.popupAncillary=ancillary;

        setIsViewAncillaryRequestModalVisible(true);
      }      
    
    const EditAncillaryRequestIcon = ({ancillary, currentRequest}) => {
        const currentAncillaryRequest = currentRequest?.ancillaries?.find(anc => anc.ancillaryVehicleId === ancillary.id);
        let showEditIcon = (ancillary?.id === currentAncillaryRequest?.ancillaryVehicleId);
    
        return (
                <div>
                {
                (showEditIcon)
                ?
                <EditOutlined style={{ fontSize: '20px' }} //in keeping with default DataCards edit button
                              onClick={() => editAncillaryRequest(ancillary, currentRequest)}
                />
                :
                <PlusOutlined style={{ fontSize: '20px' }} //in keeping with default DataCards edit button
                              onClick={() => editAncillaryRequest(ancillary, currentRequest)}/>
                }
               <ReviewAncillaryBookingRequest vehicle={vehicle}
                                           isViewAncillaryRequestModalVisible={isViewAncillaryRequestModalVisible}
                                           currentRequest={currentRequest}
                                           setCurrentRequest={setCurrentRequest}
                                           setIsViewAncillaryRequestModalVisible={setIsViewAncillaryRequestModalVisible}
                                           form={ancillaryForm}
            > 
            </ReviewAncillaryBookingRequest>                
               
               </div>
               )
            
      }

    const header = (ancillary) => {
        return ancillary?.descriptionPlusSerialNo;
    }

    const detail = (ancillary) => {
        var { Text } = Typography;
    
        return (
            <div>
               <Row style={{width:'100%'}} 
                    align="middle" 
                    justify="space-between"
               >
                  <Col span={22}>
                    <ViewNextServiceDetail nextService={ancillary?.nextScheduledEvent}></ViewNextServiceDetail>
                  </Col>
                  <Col span={2}>
                      <table>
                        <tbody>
                            <tr>
                                <td style={{ width: '200px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'right' }}>
                                        <EditAncillaryRequestIcon  ancillary={ancillary} currentRequest={currentRequest} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                      </table>
                    </Col>                  
               </Row>
               <Row>
                  <Col>
                      {
                      ancillary?.testExpiryDate
                      ?
                      <table>
                        <tbody>
                            <tr>
                                <td><CalendarOutlined style={{fontSize:"20px", marginRight:"true"}}/></td>
                                <td><Text style= { ancillary?.hasRegulatoryTestExpiredOrDuetoExpire ? {color: 'var(--dp-status-colour-danger)'} : {}}>{ t('message.test_expiry_detail', {0: ancillary?.testExpiryDate}) }</Text></td>
                            </tr>
                        </tbody>
                      </table>
                      :
                        <></>
                    }                   
                  </Col>
                </Row>
            </div>
        );
    }    

    return (
        (vehicleAncillaries)
        ?
        <div>
            <DataCards items={vehicleAncillaries} 
                       title={t('title.licence_details')} 
                       header={header} 
                       detail={detail} 
            />
        </div>
        :
        <></>
    );
}

export default AncillariesCardView;